import { SetFullScreenModal } from '@customTypes/setFullScreenModal'
import ConfirmPage from '@features/account/components/M55SignupForm/ConfirmPage'
import SetPasswordStep from '@features/account/components/M58ForgotPasswordForm/SetPasswordStep'
import { selectModalProps } from '@redux/modalSlice'
import { useAppSelector } from '@redux/store'
import { FC } from 'react'
import s from './ResetPasswordModal.module.scss'

interface Props {}
type NativeAttrs = Omit<React.HTMLAttributes<HTMLDivElement>, keyof Props>

export type ResetPasswordModalProps = Props & NativeAttrs & SetFullScreenModal

const ResetPasswordModal: FC<ResetPasswordModalProps> = ({ setFullScreen }) => {
  const modalProps = useAppSelector(selectModalProps)
  const { data } = modalProps

  let email, token

  try {
    const decodedToken = atob(data?.tokenString)
    ;[email, token] = decodedToken.split('|')

    if (!email || !token) {
      throw new Error('Decoded token format is invalid')
    }
  } catch (error) {
    console.log('Invalid or improperly formatted token:', error)
  }

  // useEffect(() => {
  //   if (setFullScreen) setFullScreen('mobile')
  // }, [])

  return (
    <div className={s.root}>
      <div className={s.headline}>CHANGE PASSWORD</div>

      {!data?.tokenString ? (
        <>
          <ConfirmPage
            text={data.forgotPasswordText}
            email={data.email}
            type="ResetPassword"
            isSignedIn
          />
        </>
      ) : (
        <SetPasswordStep disableLoginSwitch email={email} token={token} />
      )}
    </div>
  )
}

export default ResetPasswordModal
